import { useFetchLog } from '../../Hooks/useFetchLog';
import {
  StyledSideSheet,
  StyledTextarea,
  StyledTextField,
} from './LogSideSheet.styled';

export const LogSideSheet = ({
  toggle,
  setToggle,
  computeCaseId,
}: {
  toggle: boolean;
  setToggle: (toggle: boolean) => void;
  computeCaseId: string;
}) => {
  const { data } = useFetchLog(computeCaseId);

  return (
    <StyledSideSheet
      open={toggle}
      onClose={() => setToggle(!toggle)}
      title="Log file"
    >
      {data?.data ? (
        <StyledTextarea
          id={computeCaseId}
          readOnly
          rows={40}
          value={data.data as string}
        />
      ) : (
        <StyledTextField
          id={computeCaseId}
          readOnly
          value={'Could not load log file'}
        ></StyledTextField>
      )}
    </StyledSideSheet>
  );
};
